import React, { useEffect, useState } from 'react';
import { Avatar, Badge, Button, Card, Col, Divider, Form, Image, Input, Modal, Popover, Row, Select } from 'antd';
import { useinventory } from '../InCome/InvStore';
import Meta from 'antd/es/card/Meta';
import { MAIN_URL } from '../../Constants';
import { useShItems } from '../Pos/ShItemsStore';
import { Option } from 'antd/es/mentions';
import axios from 'axios';

function Perenos(props) {
    let [data, setData] = useState([])
    let [prns, setPrns] = useState([])
    let { products, fetchProducts } = useinventory()
    let { shops, getShops } = useShItems()
    useEffect(() => {
        fetchProducts()
        getShops()
    }, [])

    useEffect(() => {
        setData(products.sort((a, b) => a.count - b.count).reverse())
    }, [products])

    let filterProducts = (text) => {
        let query = text.toLowerCase().trim();
        setData(products.filter(item => {
            const nameMatch = item.product_name.toLowerCase().includes(query);
            const skuMatch = item.sku.toLowerCase().includes(query);
            return nameMatch || skuMatch;
        }))
    }

    return (
        <>
            <Modal>

            </Modal>
            <Row gutter={16}>
                <Col span={18}>
                    <h3 style={{ marginBottom: '15px' }}>Maxsulotlar</h3>

                    <Input onInput={(e) => filterProducts(e.target.value)} size='large' />

                    <div style={{ marginTop: '15px', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px , 1fr))', gap: '16px' }}>
                        {data.map(pr => {
                            return (
                                <Card
                                    key={pr.id}
                                    title={pr.product_name}
                                    extra={<Badge size="default" count={pr.count}>
                                        <Popover
                                            content={<Form onFinish={(v) => setPrns([...prns, v])}>
                                                <Form.Item name={'pr_count'} rules={[{ required: true, message: 'Kerakli qiymatni kiriting!' }]}>
                                                    <Input type='number' min={0} max={pr.count} />
                                                </Form.Item>
                                                <Form.Item name={'pr_id'} initialValue={pr.id} hidden>
                                                    <Input type='hidden' />
                                                </Form.Item>
                                                <Form.Item name={'product_name'} initialValue={pr.product_name} hidden>
                                                    <Input type='hidden' />
                                                </Form.Item>
                                                <Form.Item name={'img'} initialValue={pr.img} hidden>
                                                    <Input type='hidden' />
                                                </Form.Item>
                                                <Form.Item>
                                                    <Button htmlType='submit' type='primary'>Saqlash</Button>
                                                </Form.Item>
                                            </Form>}
                                            title={pr.product_name + "dan nechta yuboramiz? "}
                                            trigger="click"
                                        >
                                            <Button disabled={pr.count <= 0} type={pr.count <= 0 ? "danger" : "primary"}> {pr.count <= 0 ? "Qolmagan" : "Perenos"}</Button>
                                        </Popover>
                                    </Badge>}
                                    variant="borderless"
                                >
                                    <Meta title={pr.category_name}
                                        avatar={<Image src={MAIN_URL + '/' + pr.img} width="80px" />}
                                        description={pr.parametr}
                                    />
                                </Card>
                            )
                        })}
                    </div>
                </Col>
                <Col span={6}>
                    <div style={{ boxShadow: 'inset 0px 0px 15px -10px gray', height: '100%', borderRadius: '15px', padding: '15px' }}>
                        <Form layout='horizontal' onFinish={(v => {
                            let s = prns.map(p=>({
                                vr_id: p.pr_id, 
                                count: p.pr_count, 
                                outcome: "Sklad",
                                income: v.shop_id, 
                                status: 1, 
                                respondent_out: 0, 
                                respondent_in: v.shop_id
                            }))

                            axios.post('perenos', s).then(res=>{})

                        })}>
                            <Row>
                                <Col span={16}>
                                    <Form.Item name={"shop_id"}>
                                        <Select options={shops.map(sh => ({ label: sh.shopname, value: sh.id }))} size='large' />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item>
                                        <Button block size='large' htmlType='submit' type='primary'>Saqlash</Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>

                        <Divider />

                        <div>
                            {prns.map(prn => {
                                return (
                                    <Card
                                        key={prn.pr_id}
                                        title={prn.product_name}
                                        extra={<Button type={"primary"} danger onClick={() => {
                                            setPrns(prns.filter(p => p.pr_id !== prn.pr_id))
                                        }}> Bekor qilish</Button>}
                                        variant="borderless"
                                    >
                                        <Meta title={<h3>{prn.pr_count + "ta"}</h3>}
                                            avatar={<Image src={MAIN_URL + '/' + prn.img} width="60px" />}
                                        />
                                    </Card>
                                )
                            })}
                        </div>


                    </div>
                </Col>
            </Row>
        </>
    );
}

export default Perenos;